import FormTpl from '../../../components/FormTpl/index'
import eventHub from '../../../utils/eventHub'
import mapSchemas from '../../../utils/mapSchemas'

export default {
  name: 'EditDialog',
  render (h) {
    return (
      <el-dialog
        class={`sp-${this.data.name}-dialog`}
        title={this.$i18n(`${this.appName} ${this.data.resourceName}`)}
        width="80%"
        visible={true}
        beforeClose={this.cancel}
        on-before-close={val => this.formData[this.tabSchema[0].key] = val}
      >
        <FormTpl
          class="sp-edit-page-form"
          model={this.formData}
          fields={this.editableSchema}
          options={{ disabled: this.isDetail }}
        />
        {this.nestedList && this.nestedList.map(v => h(v))}
        {
          !this.isDetail && (
            <span slot="footer">
              <el-button on-click={this.cancel}>{this.$i18n('Cancel')}</el-button>
              <el-button type="primary" on-click={this.confirm}>{this.$i18n('Confirm')}</el-button>
            </span>
          )
        }
      </el-dialog>
    )
  },
  data () {
    return {
      cancelText: this.$i18n('Confirm Cancel ?'),
      confirmText: this.$i18n('Confirm ?'),
      confirming: false,
      defaultFormData: {}
    }
  },
  computed: {
    ...mapSchemas(),
    formData () {
      return this.model || this.defaultFormData
    },
    appName() {
      if (this.model && this.isDetail) {
        return 'Detail'
      }
      if (this.model) {
        return 'Edit'
      }

      return 'Add'
    }
  },
  props: ['schema', 'data', 'model', 'isDetail', 'nestedList'],
  methods: {
    cancel () {
      this.$confirm(this.cancelText)
        .then(() => eventHub.$emit('closeSubPage'))
        .catch(() => {})
    },
    confirm () {
      if (this.confirming) return
      this.confirming = true
      const resourceName = this.data.resourceName.toLocaleLowerCase() + '_id'
      this.formData[resourceName] = this.formData[resourceName] || this.formData['id']
      this.$confirm(this.confirmText).then(async () => {
        if (this.model) {
          if (this.data && this.data.update) {
            await this.data.update(this.$store, this.formData)
          }
        } else {
          if (this.data && this.data.add) {
            await this.data.add(this.$store, this.formData)
          }
        }
        eventHub.$emit(`${this.data.name}listOnSearch`)
        eventHub.$emit('closeSubPage')
        this.confirming = false
      }).catch(() => this.confirming = false)
    }
  }
}



// WEBPACK FOOTER //
// ./packages/creator/ListView/add/modalAdd.js